import { Box, Skeleton } from '@mui/material';
import { VideoEditionsCategoryToolbar } from './VideoEditionsCategoryToolbar';
import { VideoEditionsEditGridSkeleton } from './VideoEditionsEditGridSkeleton';

/**
 * Full tab skeleton: PageToolbar chip row + create action (as in {@link VideoEditionsEditList})
 * and a grid of card placeholders.
 */
export function VideoEditionsEditListSkeleton() {
  return (
    <Box>
      <VideoEditionsCategoryToolbar>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Skeleton variant="rounded" animation="wave" width={220} height={32} />
            <Skeleton variant="rounded" animation="wave" width={180} height={32} />
          </Box>
          <Skeleton variant="rounded" animation="wave" width={120} height={32} />
        </Box>
      </VideoEditionsCategoryToolbar>
      <Box sx={{ mt: 2 }}>
        <VideoEditionsEditGridSkeleton />
      </Box>
    </Box>
  );
}
